import {
    USUARI_INICIALITZAR,
    USUARI_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS,
    USUARI_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA
} from '../../../actions/actionTypes';

const ESTAT_INICIAL = false;

const peticioEnviarFormulariEnCurs = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case USUARI_INICIALITZAR:
            return ESTAT_INICIAL;

        case USUARI_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS:
            return true;

        case USUARI_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA:
            return false;

        default:
            return state;
    }
};

export default peticioEnviarFormulariEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/usuari/formulari/peticioEnviarFormulariEnCurs.js